import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { fetchAuthSession, fetchUserAttributes } from 'aws-amplify/auth';
import { JwtHelperService } from "@auth0/angular-jwt";
import { from } from 'rxjs';
import { map, catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  myVariable: any;
  constructor() { }

  public async isAuthenticated() {
    return await this.retrieveIdToken()
      .then(token => {
        // console.log(token);
        let tokenId = token.toString();
        const helper = new JwtHelperService();
        return token !== null && !helper.isTokenExpired(tokenId);
      })
      .catch(() => {
        console.log("no session")
        return false;
      });
  }

  async retrieveIdToken(){
    return await fetchAuthSession()
        .then(data => {
          if (data.tokens && data.tokens.idToken){
            return data.tokens.idToken.toString();
          }
          else{
            return{message: "Session Invalid."};
          }
        })
        .catch(err => { return {message: "Session Invalid."};
        })
  }

  isVerified(){
    return from(fetchUserAttributes());
  }
}
